import { format } from "date-fns";

import { Value } from "react-calendar/dist/cjs/shared/types";
import { API_DATE_FORMAT } from "constants/index";

export const getDatePayload = (date: Date | Value | null | undefined) => {
  if (!date || Array.isArray(date)) return "";
  return format(date, API_DATE_FORMAT);
};
